import Link from "next/link";
import { ORGANIZATION } from "@/lib/seo/constants";

const linkClass =
  "text-[#54169C] hover:text-[#DA159B] underline font-semibold";

/** One clinic in Dubai Healthcare City. Neighbourhood names are catchment, not branches. */
export function CatchmentNote() {
  return (
    <section className="mb-8 bg-gray-50 border border-gray-200 rounded-2xl p-6">
      <h2 className="text-2xl font-semibold mb-3 text-[#54169C]">
        Families who visit us from across Dubai
      </h2>
      <p className="text-gray-700 leading-relaxed mb-3">
        The Speech Clinic has one location: {ORGANIZATION.streetAddress}.
        Families visit this Dubai Healthcare City clinic from other parts of
        Dubai, including Bur Dubai, Oud Metha, Downtown Dubai, Business Bay,
        Jumeirah, and Al Jaddaf.
      </p>
      <p className="text-gray-700 leading-relaxed">
        Those area names describe where families travel from. They are not
        separate clinic branches.{" "}
        <a
          href={ORGANIZATION.mapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={linkClass}
        >
          View the clinic on Google Maps
        </a>{" "}
        or{" "}
        <Link href="/contact-us" className={linkClass}>
          contact the clinic
        </Link>
        .
      </p>
    </section>
  );
}
